<template>

  <div class="ma-detail" :style="{'padding-top' : detail.type != 6 && vcardUrl ? '0' :'0'}">
    <div v-if="vcardData" class="_a_position_f" style="background: #FFF;position: sticky;top:0;z-index:10;padding:0 16px;box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);">
     <VcardHeader
        :posterData="vcardData"
        @showVcard="showVcard"
      ></VcardHeader>
    </div>
    <div class="ma-title">{{ detail.title }}</div>
    <div class="sub-title flex-center">
      <div></div>
      <div class="flex-center">
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/ae085340a78e4e9a828b733304583188.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.readnum }}
        </div>
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/cb636b484f964256958e1b2f47825cf5.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.sharenum }}
        </div>
        <div class="flex-center" style="margin-right:8px;">
          <img
            src="https://img.esenyun.com/images/20200325/b2b6b40900a74cf08b4c1d4bc10610f6.png"
            style="width: 16px; height: 16px; margin-right: 2px;"
          />
          {{ detail.readpeople }}
        </div>
      </div>
    </div>
      <div v-if="!showModal&&detail.content">
      <AnchoredHeading :html="detail.content" :id="detail.id" :route='$route.query' :vcardData="vcardData"/>
    </div>
    <div v-if="detail.type === 2">
       <lazy-component>
      <img style="width: 100%;" mode="widthFix"  v-lazy="detail.url"/>
      </lazy-component>
    </div>
    <div class="radio-container" v-show="detail.type === 7">
      <div
        class="pic flex-center"
        :style="{ background: `url('${detail.pic}')` }"
      >
        <div
          class="flex-center"
          v-show="playerStatus === 'loading'"
          style="border-radius: 50%;width: 54px;height:54px; background: #1F7DDE;justify-content:center"
        >
          <van-loading color="#fff" />
        </div>
        <img
          class="opt-icon"
          @click="changePlayer('play')"
          v-show="!isPlay && playerStatus !== 'loading'"
          src="https://img.esenyun.com/images/20200709/df1263b3c88d42c18377c5f390915c56.png"
        />
        <img
          class="opt-icon"
          @click="changePlayer('paused')"
          v-show="isPlay && playerStatus !== 'loading'"
          src="https://img.esenyun.com/images/20200709/f3222aa866c74b8eb4138589c2895b0f.png"
        />
      </div>
      <div class="tip">内容由喜马拉雅APP提供</div>
      <div
        class="flex-center"
        style="justify-content: space-between;color:#fff; padding:0 16px"
      >
        <van-count-down
          :time="time"
          :auto-start="false"
          format="mm:ss"
          ref="countDown"
        />
        <div style="width: calc(100% - 42px - 70px);padding: 0 1px;">
          <van-slider v-model="value" @change="onChange" />
        </div>
        <van-count-down
          :time="totalTime"
          :auto-start="false"
          ref="countDownTotal"
          format="mm:ss"
        />
      </div>
    </div>
    <div style="margin: 12px 8px;" v-show="detail.type === 7 && isiOS">
      <div class="ios-tip">
        温馨提示：iOS系统的部分机型可能存在微信播放限制，您可尝试退出微信后再次进入收听
        ~
      </div>
    </div>
    <div style="padding: 0 24px;" v-if="detail.type === 6||detail.type === 8">
      <div class="f-text" v-if="detail.moments_text">{{ detail.moments_text }}</div>
      <van-grid :gutter="10" :column-num="3" :border="false" v-if="detail.moments_pics.length > 1">
        <van-grid-item
          use-slot
          :key="item.material_file"
          v-for="item in detail.moments_pics"
        >
        <van-image :src="item.material_file" height="90" @click="preview(item.material_file,index)"/>  
          <!-- <img style="width: 90px; height: 90px;" :src="item.material_file" /> -->
        </van-grid-item>
      </van-grid>
      <div v-else>
         <lazy-component>
           <img
            style="width: 100%"
            mode="widthFix"
            @click="preview(item.material_file)"
            :key="item.material_file"
            v-for="item in detail.moments_pics"
            v-lazy="item.material_file"
          />
          </lazy-component>
         
        </div>
    </div>
    <div class="copywriter" v-if="detail.copywriter">{{detail.copywriter}}</div>
    <!-- 福利活动 -->
    <div
      style="border-top: 8px solid #F7F8FA; padding: 15px 0;"
      v-if="activityList.length>0||cardBagDTOSList.length>0||couponDTOSList.length>0||seckillDTOSList.length>0"
    >
      <div style="text-align:center; padding-top:12px;">
        <img
          src="https://img.esenyun.com/images/20200710/103fe04d9d994e0abc53d9052b2f2d29.png"
          style="width:144px;height:22px;"
        />
      </div>
      <div
        style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
        v-for="item in activityList"
        :key="item.activityId"
      >
        <ActivityCard :item="item" :vcardUrl="vcardUrl" :envMp="envMp" />
        </div>
        <div  v-if="cardBagDTOSList.length">
           <div
              style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
              v-for="item in cardBagDTOSList"
              :key="item"
            >
              <cardBag :cardData="item" :shareId="item.shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"/>
            </div>
          </div>
      <div v-if="couponDTOSList.length">
          <div
          style="margin: 12px 16px 0 16px;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08); border-radius: 5px;"
          v-for="item in couponDTOSList"
          :key="item"
        >
          <rollCard :rollDetail="item" :shareId="item.shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"/>
        </div>
      </div>
      <div class="flash-sales" style="margin: 12px 0;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);padding:0 16px" v-if="seckillDTOSList.length">
         <salesCard :list='seckillDTOSList' :vcardData="vcardData" :vcardUrl="vcardUrl"></salesCard>
       </div>
    </div>
    <!-- 相关资讯-->
    <div
      style="text-align:center;border-top: 8px solid #F7F8FA;padding-top: 12px;"
      v-if="recommands && recommands.length"
    >
      <img
        style="width: 144px; height:22px;"
        src="https://img.esenyun.com/images/20200710/f4e7f9154c0b4972929e248c152ddf2d.png"
      />
    </div>
    <!-- 相关资讯-->
    <div
      style="padding: 0 16px;"
      v-for="item in recommands"
      :key="item.id"
      @click="link(item.id)"
    >
      <materialCard :item="item" />
    </div>
    <div class="footer" v-if="envMp">
      <div class="video-btn btn flex-center">
        <van-button
          type="primary"
          round
          style="width: 100%;border: none; background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);"
          @click="openShare"
          >一键分享</van-button
        >
      </div>
      <div style="height: 32px;"></div>
    </div>
    <div v-if="vcardData&&callingcardShow">
      <VCardNew
        :posterData="vcardData"
        :eacrdImg="eacrdImg"
        @showMark="()=>callingcardShow=false"
        @imgOK="onImgOK"
      ></VCardNew>
    </div>
    <!-- <van-image-preview v-model="showPreview" :images="showPreviewUrl" @change="onChangeSuccessImgs" @close="()=>showPreview=false">
        <template v-slot:successImgsIndex>第{{ successImgsIndex }}页</template>
      </van-image-preview> -->
  </div>
</template>

<script>
const { config, XMplayer } = window.xmsdk
import Vue from 'vue'
import env from '@/config/env'
import ActivityCard from '@/components/activityCard'
import salesCard from '@/components/card-slot/salesCard'
import rollCard from '@/components/card-slot/roll'
import cardBag from "@/components/card-slot/card"
import materialCard from '@/components/materialCard'
import VcardHeader from '@/components/VcardHeader'
import VCardNew from "@/components/VCardNew"
import AnchoredHeading from "@/components/anchoredHeading"
// import md5 from '../components/md5'
import moment from 'moment'
import { Toast } from 'vant'
let yssdk = require("ys-sdk")("production");
if(env.env === 'test') {
  yssdk = require("ys-sdk")("test");
}
import { v4 as uuidv4 } from 'uuid'
export default {
  components: {
    VcardHeader,
    VCardNew,
    materialCard,
    ActivityCard,
    cardBag,
    salesCard,
    rollCard,
    AnchoredHeading
  },
  data() {
    return {
      callingcardShow:false,
      eacrdImg:"",
      shareId:"",
      moment: moment,
      mType: 'tezan',
      id: '',
      time: null,
      totalTime: null,
      totalSound: null,
      isPlay: false,
      firstPlay: true,
      rate: null,
      value: null,
      player: null,
      playerStatus: '',
      countDown: null,
      recommands: [],
      insertActivityId: '',
      show: false,
      downloadText: '',
      Wxmpfrom: '',
      showShare: false,
      showBg: false,
      vcardUrl: '',
      vcardData: null,
      poster: {
        width: '280px',
        height: '498px',
        views: [
          {
            type: 'img',
            url: '',
            css: {
              width: '280px',
              height: '498px',
              top: '0',
              left: '0',
            },
          },
          {
            type: 'text',
            text: '扫码',
            css: {
              color: '#fff',
              fontSize: '11px',
              lineHeight: '16px',
              bottom: '51px',
              left: '60px',
            },
          },
          {
            type: 'img',
            url:
              'https://img.esenyun.com/images/20200324/21368348090240e09d7da955ef4a5c8f.png',
            css: {
              width: '32px',
              height: '32px',
              borderRadius: '16px',
              bottom: '34px',
              left: '20px',
            },
          },
          {
            type: 'img',
            url:
              'https://img.esenyun.com/images/20200324/21368348090240e09d7da955ef4a5c8f.png',
            css: {
              width: '60px',
              height: '60px',
              bottom: '20px',
              right: '20px',
            },
          },
          {
            type: 'text',
            text: '扫码联系服务专家，了解更多',
            css: {
              color: '#fff',
              fontSize: '8px',
              lineHeight: '12px',
              left: '60px',
              bottom: '37px',
            },
          },
        ],
      },
      showModal: false,
      posterData: {},
      video: '',
      videoId: '',
      Loading: null,
      percent: 0,
      currentIndex: 0,
      img: '',
      successImgs: [],
      friendImgs: [],
      activityList: [],
      cardBagDTOSList:[],
      couponDTOSList:[],
      seckillDTOSList:[],
      downloadTask: null,
      detail: {},
      envMp: false,
      sounds: null,
      videoContainer: null,
      isiOS: false,
      tezanSdk: null,
      contentShareId:"",
      multiChannelId:"",//渠道id
      showPreview:false,
      showPreviewUrl:null,
      successImgsIndex:0,
    }
  },
  async mounted() {
    const u = navigator.userAgent
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    this.init()
    if (window.__wxjs_environment === 'miniprogram') {
      this.envMp = true
    }
  },
  destroyed(){
    if (this.mType !== 'ao') {
      this.tezanSdk.event_page_unload()
    }
  },
  methods: {
    preview(file,index) {
      // this.showPreviewUrl=this.detail.moments_pics.map((i) => i.material_file)
      // this.showPreview=true
      // this.$ImagePreview({
      //   images:url, // 当前显示图片的http链接
      //   startPosition:index, // 需要预览的图片http链接列表
      // })
       this.successImgsIndex = index;
       this.showPreviewUrl=this.detail.moments_pics.map((i) => i.material_file)
      // this.showPreview=true
      this.$ImagePreview({
        images:this.showPreviewUrl, // 当前显示图片的http链接
        startPosition:index, // 需要预览的图片http链接列表
        closeOnPopstate:true
      })
    },
    onChangeSuccessImgs(index){
      this.successImgsIndex = index;
    },
    changePlayer(status) {
      if (status&&status === 'play') {
        if (this.playerStatus === 'advertising') return
        this.player.play(this.videoId)
      } else {
        if (this.playerStatus === 'advertising') return
        this.player.pause()
      }
    },
    openShare() {
      let url = `/material/detail?id=${this.id}&from=${this.mType}`
      window.wx.miniProgram.navigateTo({
        url: url,
      })
    },
    async finish() {
      console.log('播放完毕')
      this.value = 0
      this.time = this.totalTime
      await this.$share.sleep(1)
      this.$refs.countDown.pause()
    },
    onChange(value) {
      this.player.play()
      this.player.seek(value * this.rate)
      this.time = (this.totalSound - value * this.rate) * 1000
    },
    initVideo() {
      // this.$http.post(
      //   'https://testmoawx.hotwater.com.cn/cfsite/mobile/material/xmly/sign'
      // )
      if (this.firstPlay) {
        this.videoContainer = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '播放器加载中..',
        })
        this.firstPlay = false
      }
      config({
        app_key: 'f5f999fa36fef65454751700e21e734e', // 必传，官方提供的 app_key：b617866c20482d133d5de66fceb37da3 仅供测试，有调用次数限制，上线需替换为自己的 app_key。
        // 官方提供测试使用的 sig_url => https://api.ximalaya.com/openapi-collector-app/jssdk_sig
        // （限制了 app_key 必须是测试账号，并且限制了调用次数，上线需替换为自己的 sig_url）
        sig_url: `https://open-api.tezign.com/open-api/v1/common/xmly/sign`, // 免登录授权，必须传 sig_url，和 get_access_token 互斥
        // sig_url: `${env.materialUrl}cfsite/mobile/material/xmly/sign`, // 免登录授权，必须传 sig_url，和 get_access_token 互斥
        debug: true, // 是否在控制台打印日志
      })
      // 创建音频播放器，播放喜马拉雅声音
      const player = new XMplayer({
        breakpoint: false,
        autoUnlock: false,
        playlist: [this.videoId],
      })
      player.preloadSound(this.videoId)
      this.player = player
      player.on('timeupdate', (position, sound) => {
        this.value = (position / sound.duration) * 100
        this.time =
          sound.duration - position > 0 ? (sound.duration - position) * 1000 : 0
        if (sound.duration - position <= 0) {
          player.stop()
          player.seek(0)

          this.value = 0
        }
      })
      player.on('ready', () => {
        if (this.videoContainer) {
          this.videoContainer.close()
        }
      })
      player.on('loading', (percent) => {
        console.log(percent)
      })
      player.on('change.playState', (playState) => {
        this.playerStatus = playState
        if (playState === 'playing') {
          this.isPlay = true
          if (this.sounds) {
            this.sounds.close()
          }
        }
        if (playState === 'advertising') {
          this.isPlay = true
        }
        if (playState === 'paused') {
          this.isPlay = false
        }
        console.log('状态', playState)
      })
      player.on('loaderror', (e) => {
        Toast('加载失败')
        Toast(e.message)
      })
      player.on('notAllowedError', () => {
        Toast('浏览器限制，需要再次点击播放')
      })
      player.on('sound.unusable', () => {
        Toast('获取音频信息失败')
      })
      player.on('sound.notExist', () => {
        Toast('查询不到该声音信息')
      })
      player.on('play', async (res) => {
        console.log('播放')
        if (!this.time) {
          this.time = res.duration * 1000
          this.totalTime = res.duration * 1000
          this.totalSound = res.duration
          this.rate = res.duration / 100
        }
      })
      player.on('resume', () => {
        console.log('恢复播放')
        this.$refs.countDown.start()
      })
    },
    async init() {
      this.mType = this.$route.query.from || 'tezan'
      console.log('this.$route.query.from', this.$route.query.from)
      this.shareId = this.$route.query.shareId
      this.contentShareId=JSON.stringify({contentShareId:this.shareId});
      this.id=this.$route.query.id
      this.multiChannelId=this.$route.query.multiChannelId
      this.vcardData=await this.getCardDetail()
      await this.getData(this.$route.query.id)
      if(this.vcardData){
        this.readyShare()
        if(!localStorage.getItem('uuid')) {
          const uuid = uuidv4()
          localStorage.setItem('uuid', uuid)
        }
        if (this.mType !== 'ao') {
          this.tezanSdk = new yssdk.Log({
            unionId: null,
            userId: localStorage.getItem('uuid'),
            openId: null,
            character: 'customer',
            clientHeight: window.screen.height,
            contentId: this.$route.query.id ? Number(this.$route.query.id) : null,
            sellerId: this.vcardData.userId,
            sellerName: this.vcardData.name,
            isShared:true,
            sourceFrom:this.multiChannelId
            // logType: '',
          })
          this.tezanSdk.event_page_pv()
          this.tezanSdk.event_page_access_time()
        }
      }
      
    },
    openModal(e) {
      this.showModal = e
    },
    async link(id) {
      if (this.envMp) {
        if (this.detail.type === 7) {
             let redirectUri='material'
              let url=`id=${id}&vcardUrl=${this.vcardUrl}&from=${this.mType}&vcardData=${encodeURIComponent(JSON.stringify(this.vcardData))}&shareId=${encodeURIComponent(JSON.stringify(this.shareId))}&multiChannelId=${this.multiChannelId}` 
              Vue.ss.set('pageUrl',url)
              console.log('redirectUri',redirectUri)
              Vue.ss.set('redirectUri',redirectUri)
              console.log(url)
              console.log('pageUrl',Vue.ss.get('pageUrl'))
              if(this.$store.getters.isWeiXin){
                await this.$store.dispatch("wxLogin/wxLogin");
              }else{
                  this.$Dialog.alert({
                    message: '请在微信客户端打开链接',
                  }).then(() => {
                    // on close
                  });
              }
          } 
      }
    },
    //初始化分享
    getForward(){
        console.log('初始化分享')
        return new Promise((s)=>{
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/forward-init/CUSTOMER/${this.shareId}?openId=${Vue.ls.get('ssOpenId')}`)
          .then((res) => {
            console.log('初始化分享id',res.data)
            if(res.data&&res.data.shareId){
              s(res.data.shareId)
            }
          })
        })
    },
    async readyShare() {
        let that=this;
         let forwardShareid=await that.getForward()
         if(forwardShareid){
           console.log('初始化分享获得id',forwardShareid)
          window.wx.ready(async () => {
            console.log(112,forwardShareid)
            const shareUrl = `${location.origin}${location.pathname}#/electronicCard/details?shareId=${forwardShareid}`
            console.log('shareUrl',shareUrl)
            console.log('this.callingcard',this.vcardData)
            //需在用户可能点击分享按钮前就先调用
            window.wx.onMenuShareAppMessage({
              title: '分享这个不错的 A.O.专业顾问给你', // 分享标题
              desc: this.vcardData.name +" "+ this.vcardData.position, // 分享描述
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:'https://aosnext-test-img.hotwater.com.cn/images/20210423/a5a9a792604342b2985f5a627ce9a8cc.png', // 分享图标
              success: () => {
                that.shareSuccess(forwardShareid)
                // 用户点击了分享后执行的回调函数
              },
            })
            window.wx.onMenuShareTimeline({
              title: '分享这个不错的 A.O.专业顾问给你', // 分享标题
              link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:'https://aosnext-test-img.hotwater.com.cn/images/20210423/a5a9a792604342b2985f5a627ce9a8cc.png', // 分享图标
              success: () => {
                that.shareSuccess(forwardShareid)
                // 用户点击了分享后执行的回调函数
              },
            })
          })
         }
      },
      //转发分享
      shareSuccess(forwardShareid){
        console.log('转发成功',forwardShareid)
        this.$http
          .get(`aocampaigncallingcard/openapi/customer/callingcard/forward/${forwardShareid}?openId=${Vue.ls.get('ssOpenId')}&spreadSource=CUSTOMER&spreadStatus=SUCCESS`)
          .then(() => {
          })
      },
    getAPI(id) {
      return this.$http(
          `aocampaign/openapi/tezign/getMaterialDetail?materialId=${id}&channelCode=${this.multiChannelId}`
        )
    },
    getData(id) {
      return new Promise((s) => {
        this.getAPI(id).then(async (res) => {
          if (res.data.error) {
            this.$Toast(res.data.message)
          }
          s()
          let data = {}
          if (this.mType !== 'ao') {
            data = res.data.result
          } else {
            data = res.data
          }
          this.detail = data.model
          document.title = data.model.title
          console.log('detail', this.detail)
          let recommands = data.recommands
          if (recommands && recommands.length) {
            recommands.forEach((item) => {
              item.type = 1
              item.display_type = 1
              item.recommands = true
            })
            this.recommands = recommands
          }
          if (this.detail.type === 7) {
            this.videoId = +this.detail.platform_content_id
            this.initVideo()
            return
          }
          if(this.detail && this.detail.content) {
            this.detail.content = this.detail.content.replace('http://material.aosmith','https://material.aosmith')
            // eslint-disable-next-line
            this.detail.content = this.detail.content.replace(/<img/gi,'<img class="rich-img" ')
            this.detail.content = this.detail.content.replace(/<section/gi,'<section class="rich-section" ')
          }
          if(this.detail.url) {
            console.log('url', this.detail.url)
            this.detail.content = `<video style="width: 100%;" poster="${this.detail.pic}" src="${this.detail.url}" controls></video>`
          }

          if(this.detail && this.detail.content) {
            this.detail.content = this.detail.content.replace(/<h1/gi,'<h1 style="line-height: 45px;" ')
            this.detail.content = this.detail.content.replace(/<h2/gi,'<h2 style="line-height: 35px;" ')
          }
        })
      })
    },
     //查看名片基础信息
      getCardDetail(){
        return new Promise((s)=>{
          this.$http
            .get(`aocampaigncallingcard/openapi/customer/callingcard/cardDetail/${this.shareId}`)
            .then((res) => {
              s(res.data)
            })
        })
      },
      showVcard(){
        this.callingcardShow=true
      },
      //海报成功
      onImgOK(e){
        this.eacrdImg=e
      }
    
  },
}
</script>

<style lang="less">
.van-slider__button {
  width: 10px !important;
  height: 10px !important;
  background: #fff;
}
.van-slider {
  background: #9ba2ab;
}
.van-slider__bar {
  height: 4px;
  background: #fff;
}
.van-count-down {
  color: #fff;
}
p {
  margin: 0;
}
body {
  background: #fff;
}
.ios-tip {
  padding: 4px 8px;
  background: #f7f8fa;
  border-radius: 3px;
  color: #4a4a4a;
  font-size: 12px;
  line-height: 20px;
}
.radio-container {
  height: 350px;
  background: #686e77;
  backdrop-filter: blur(4px);
  padding-top: 24px;
  .pic {
    margin: auto;
    width: 250px;
    height: 250px;
    position: relative;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    justify-content: center;
    box-shadow: 2px 2px 20px #35445b;
    border-radius: 5px;
    .opt-icon {
      width: 54px;
      height: 54px;
    }
  }
  .tip {
    color: #fff;
    text-align: center;
    margin-top: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 28px;
  }
}
.ma-detail {
  background: #fff;
  padding-bottom: 120px;
  padding-top: 64px;
  --popup-round-border-radius: 8px;
  --grid-item-content-padding: 0;
  img {
    display: inline-block;
  }
  /deep/.van-grid {
    padding: 0 !important;
    /deep/.van-grid-item__content {
      padding: 0 !important;
    }
  }
  .f-text {
    font-size: 16px;
    line-height: 28px;
    color: #323233;
    margin-bottom: 24px;
  }
  .video-btn {
    justify-content: space-between;
  }
  .progress {
    width: 300px;
    padding: 32px;
  }
  .video {
    width: 100%;
    height: 210px;
  }
  .rich-img {
    max-width: 100% !important;
    height: auto !important;
  }
  .rich-section {
    max-width: 100% !important;
  }
  .ma-title {
    padding: 0 16px;
    padding-top: 24px;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
  .sub-title {
    padding: 0 16px;
    padding-top: 12px;
    padding-bottom: 24px;
    font-size: 14px;
    line-height: 24px;
    color: #969799;
    justify-content: space-between;
  }
  .vcard-body {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
  }
}
.copywriter{
  padding: 16px;
  font-size: 14px;
  color: #323233;
}
</style>
